/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * The station's price state:
 *   * CREATED: Like DEMANDEE
 *   * PROCESS: Like EN COURS
 *   * DONE: Like TERMINEE
 *   * ERROR: Like ERREUR
 *   * SENT: Like ENVOYEE
 *   * DELETED: Like SUPPRIMEE
 */
export enum ExportRequestState {
  INITIATED = 'INITIATED',
  CREATED = 'CREATED',
  PROCESS = 'PROCESS',
  DONE = 'DONE',
  SENT = 'SENT',
  ERROR = 'ERROR',
  DELETED = 'DELETED'
}
